import React from "react";
import { motion } from "framer-motion";
import heroBg from "../assets/hero3.png";
import heroImg from "../assets/hero-removebg-preview.png";
import { triggerBookingPopup } from "../components/Header";

const Hero = () => {
  return (
    <section className="hero-section relative min-h-screen w-full overflow-hidden flex items-center pt-32 lg:pt-28">
      {/* BG IMAGE */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${heroBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      {/* OVERLAY */}
      <div className="absolute inset-0 bg-white/20 z-10" />
      <div className="absolute inset-0 bg-gradient-to-r from-blue-100/55 via-white/10 to-transparent z-10" />

      {/* CONTENT */}
      <div className="container mx-auto px-6 lg:px-16 grid lg:grid-cols-2 gap-12 items-center relative z-10">
        {/* LEFT */}
        <div className="space-y-6">
          <br />
          <br />
          <br/>
         
          <p className="text-slate-700 text-xl lg:text-2xl max-w-lg drop-shadow-lg font-bold">
            Your comfort is our priority
          </p>
          {/* <br /> */}
          <h1 className="text-6xl lg:text-8xl font-black text-slate-900 leading-tight drop-shadow-[0_12px_28px_rgba(15,23,42,0.22)]">
            REPAIR <br />
            <span className="bg-gradient-to-r from-[#0F52BA] via-[#2563eb] to-[#FF6B00] bg-clip-text text-transparent">
              EVOLVED.
            </span>
          </h1>

 <p
  className="
    bg-gradient-to-r
    from-[#0F52BA]
    via-[#1F2937]
    to-[#FF6B00]
    bg-clip-text
    text-transparent
    text-xl
    lg:text-2xl
    max-w-lg
    font-extrabold
    leading-tight
    tracking-tight
    drop-shadow-[0_4px_10px_rgba(15,82,186,0.22)]
  "
>
  Expert repair for{" "}
  <span className="font-black">refrigerators</span> and{" "}
  <span className="font-black">washing machines</span> with fast
  service.
</p>

          <button
            onClick={triggerBookingPopup}

            className="px-8 py-4 lg:px-10 lg:py-5 
            bg-[#FF6B00] hover:bg-[#d95b00]
            text-white rounded-xl font-semibold shadow-[0_18px_36px_rgba(255,107,0,0.24)] 
            hover:scale-105 transition"
          >
            Book Repair
          </button>
        </div>

        {/* RIGHT IMAGE */}
        <motion.img
          src={heroImg}
          alt="Appliances"
          className="w-[520px] lg:w-[620px] object-contain
          drop-shadow-[0_60px_120px_rgba(0,0,0,0.4)]"
          animate={{ y: [0, -15, 0] }}
          transition={{ duration: 4, repeat: Infinity }}
        />
      </div>
    </section>
  );
};

export default Hero;







